import Splide from '@splidejs/splide';

export default {
  init() {
    const slider = document.querySelector('#products-splide');
    if (slider) {
      new Splide(slider, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        autoplay: true,
        interval: 5000,
        gap: '0px',
        height: '410px',
        arrows: true,
        pagination: false,
        breakpoints: {
          1600: { perPage: 3 },
          1400: { height: '500px' },
          640: { perPage: 1 },
        },
      }).mount();
    }

    const certs = document.querySelector('#certyfikaty-splide');
    if (certs) {
      new Splide(certs, {
        type: 'loop',
        perPage: 3,
        autoplay: true,
        interval: 5000,
        perMove: 1,
        gap: '30px',
        arrows: true,
        pagination: false,
        breakpoints: {
          1280: { perPage: 3 },
          1024: { perPage: 2 },
          640: { perPage: 1 },
        },
      }).mount();
    }

    // Init lightbox for certificates
    if (window.GLightbox) {
      window.GLightbox({ selector: '.js-cert-lightbox', touchNavigation: true, loop: false });
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js